import { render, staticRenderFns } from "./BitQEsperienze.vue?vue&type=template&id=54121cbb&scoped=true"
import script from "./BitQEsperienze.vue?vue&type=script&lang=js"
export * from "./BitQEsperienze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54121cbb",
  null
  
)

export default component.exports